import { Badge, BadgeType } from '../../../../../../components/badge/badge';

interface EligibilityStatusBadgeProps {
    isEligible: boolean;
}

const EligibilityStatusBadge: React.FC<EligibilityStatusBadgeProps> = ({ 
    isEligible
}) => {
    return (
        <Badge 
            type={isEligible ? BadgeType.SUCCESS : BadgeType.WARNING} 
            text={isEligible ? "Eligible" : "Ineligible"} 
        />
    );
};

export default EligibilityStatusBadge;
